import { actionTypes } from '../constants';


export const clearStore = () => {
    return (dispatch) => {
        dispatch({ type: actionTypes.CLEAR_ASSET_GROUP_OVERVIEW });
    };
};

export const previousSearchFilter = (searchParams) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.PREVIOUS_SEARCH_FILTER,
            searchParams
        });
    };
};

export const getAssetGroupConditionIndicesRequest = (request) => ({
    type: actionTypes.LOAD_ASSET_GROUP_CONDITION_INDICES_REQUEST,
    request
});
